import { StaticImageData } from 'next/image'

import {
  Roadmap001Image,
  Roadmap002Image,
  Roadmap003Image,
  Roadmap004Image,
} from 'Assets/Images/Sections/HowItWorksSection'

type HowItWorksSectionRoadmapItem = {
  id: string
  caption: string
  image: StaticImageData
  imageAlt: string
  title: string
}

export const HOW_IT_WORKS_SECTION_ROADMAP_ITEMS: HowItWorksSectionRoadmapItem[] =
  [
    {
      id: 'HowItWorksSectionRoadmapItem-001',
      image: Roadmap001Image,
      imageAlt: '',
      title: 'Your personalised networking curation session',
      caption:
        'Align on who will be best suited for you in our community you want to meet and list courses you want to play.',
    },
    {
      id: 'HowItWorksSectionRoadmapItem-002',
      image: Roadmap002Image,
      imageAlt: '',
      title: 'Become a member',
      caption:
        'We’ll work with you to select the best membership level to ensure you maximise the value you gain from the community.',
    },
    {
      id: 'HowItWorksSectionRoadmapItem-003',
      image: Roadmap003Image,
      imageAlt: '',
      title: 'Connect with synergy',
      caption:
        'In addition to organic networking, our Custom Connection Program hand-picks ideal connections based on your industry and requirements.',
    },
    {
      id: 'HowItWorksSectionRoadmapItem-004',
      image: Roadmap004Image,
      imageAlt: '',
      title: 'Get proactive',
      caption:
        'Download the Emajin Golf app to register for events, connect with members, and stay updated on the community.',
    },
  ]
